import { render, staticRenderFns } from "./formPost.vue?vue&type=template&id=12da69f7&scoped=true&"
import script from "./formPost.vue?vue&type=script&lang=js&"
export * from "./formPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da69f7",
  null
  
)

export default component.exports